import Vue from 'vue';

export default function () {
  Vue.component('simple-accordion', {
    data: function () {
      return {};
    },

    methods: {
      toggleActive(event) {
        const currentItem = event.currentTarget.parentElement;

        // Basic check if the structure is as expected
        if (!currentItem || !currentItem.classList.contains('accordion-item')) {
          console.warn('Accordion structure might be incorrect.');
          return;
        }

        this.$el.querySelectorAll('.accordion-item').forEach((el) => {
          if (el !== currentItem) {
            el.classList.remove('active');
          } else {
            el.classList.toggle('active');
          }
        });
      }
    }
  });
}
